import { Box } from "@mui/material";
import { keyframes } from "@mui/system";

const dotPulse = keyframes`
  0%, 80%, 100% {
    opacity: 0.2;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
`;

/**
 * Three horizontal dots that fade and pulse in sequence. Used where a value is
 * on its way but a spinner would be too heavy -- inside a DataGrid cell, for
 * instance.
 */
export const LoadingDots = ({ color = "text.secondary", size = 5 }) => (
  <Box
    aria-label="loading"
    component="span"
    display="inline-flex"
    alignItems="center"
    gap={0.5}
    role="status"
  >
    {[0, 1, 2].map((index) => (
      <Box
        component="span"
        key={index}
        sx={{
          animation: `${dotPulse} 1400ms ease-in-out infinite`,
          animationDelay: `${index * 160}ms`,
          backgroundColor: color,
          borderRadius: "50%",
          height: size,
          width: size,
        }}
      />
    ))}
  </Box>
);
